import { useRouteMatch } from 'react-router';

import { ComponentSellPrice } from 'pages/Private/Stock/ComponentSellPrice';
import { DevolutionInvoice } from 'pages/Private/Stock/DevolutionInvoice';
import { DevolutionInvoiceNoUnclass } from 'pages/Private/Stock/DevolutionInvoiceNoUnclass';
import { DevolutionInvoiceUnclass } from 'pages/Private/Stock/DevolutionInvoiceUnclass';

import { Route } from '../Route';

export const StockRoutes = () => {
  const { path } = useRouteMatch();

  return (
    <>
      <Route isPrivate path={`${path}/devolution-invoice`} component={DevolutionInvoice} />
      <Route
        isPrivate
        path={`${path}/devolution-invoiceUnclass`}
        component={DevolutionInvoiceUnclass}
      />
      <Route
        isPrivate
        path={`${path}/devolution-invoiceNoUnclass`}
        component={DevolutionInvoiceNoUnclass}
      />
      <Route
        isPrivate
        path={`${path}/update-component-sell-price`}
        component={ComponentSellPrice}
      />
    </>
  );
};
